<template>
  <div class="text-center">
    <v-card
      min-width="350"
      max-width="500"
      :class="{ 'elevation-20': !$vuetify.breakpoint.xsOnly }"
      color="#006666"
      dark
      class="rounded-lg"
    >
      <v-card-text>
        <v-flex>
          <v-flex>
            <img height="100" src="@/assets/images/logo.png" />
          </v-flex>

          <v-flex xs12>
            <div>Forgot Your Password</div>
            <small>No Problem</small>
          </v-flex>

          <v-text-field
            v-model="email"
            outlined autofocus
            :append-icon="emailErrors.length ? 'mdi-alert' : 'mdi-email'"
            :type="emailErrors.length ? 'text' : 'email'"
            @keyup.enter="submit"
            :hide-details="emailErrors.length === 0"
            :counter="100"
            dense
            :error-messages="emailErrors"
            label="Your Email Address"
          >
          </v-text-field>
        </v-flex>
        <v-layout>
          <v-spacer> </v-spacer>
          <v-btn class="mr-5 mt-5" @click="submit" color="white" outlined>Send Reset Link</v-btn>
        </v-layout>
      </v-card-text>

      <v-divider class="mt-5"></v-divider>
      <v-card-actions>
        <v-btn color="white" @click="$router.push({ path: '/login' })" text block
          >Found my password back to login</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { type } from "jquery";
import authService from "../service";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  name: "authentication-login",
  data() {
    return {
      email: null,
    };
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        authService
          .forgotPassword({
            email: this.email,
            type: "Member",
          })
          .then(() => {
            // console.log("response test user", response);
            this.$swal(
              "You are all set",
              "Check your email for a login code",
              "success"
            );

            this.$router.push({ path: "/login" });
          })
          .catch((error) => {
            console.log("error on ", error);
            this.$swal(
              "Invalid Login",
              "Check email, use save email address that you use to create an account",
              "error"
            );
          });
      }
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push("Email is not valid");
      if (!this.$v.email.required) errors.push("Email is required.");
      return errors;
    },
  },
  mixins: [validationMixin],
  validations: {
    email: {
      email,
      required,
    },
  },
};
</script>
